import React from 'react'

interface TabsProps {
    types?: { id: number, name: string, type: string, length?: number }[];
    tabType?: string;
    handleTab?: (type: string) => void;
    className?: string;
    content?: React.ReactNode;
}

const Tabs: React.FC<TabsProps> = ({ types, tabType, handleTab, className, content }) => {
    return (
        <div
            className="flex overflow-x-auto overflow-y-hidden justify-between items-start border-b border-[rgba(201,201,207,1)] pt-3 pr-3"
            style={{ scrollbarWidth: 'none' }}
        >
            {types &&
                <div className="flex gap-2">
                    {types.map((item, index) => (
                        <div key={index} className={`
                        ${className} font-montserrat cursor-pointer text-center -mb-[0.08rem] 
                        ${tabType === item.type ? 'text-secondaryColor border-b-2  pb-2 border-secondaryColor'
                                : 'text-primaryColor '
                            } font-medium`}
                            onClick={() => handleTab && handleTab(item.type)}
                        >
                            {item.name} {item.length && <span className="text-xs bg-gray-400 ml-2 rounded-xl px-2 text-primaryColor">{item.length}</span>}
                        </div>
                    ))}
                </div>
            }
            {content && content}
        </div>

    );
}

export default Tabs
